// extracted by mini-css-extract-plugin
export default {"MypostsContainer":"MypostsContainer_MypostsContainer__JRAWM","noMyposts":"MypostsContainer_noMyposts__VJSls"};